import {
  FETCH_PROFILE_REQUESTED,
  FETCH_PROFILE_FAILURE,
  FETCH_PROFILE_SUCCESS,
} from 'actiontypes/profile';

import ProfileService from 'services/ProfileService';


const fetchProfileRequest = () => ({ type: FETCH_PROFILE_REQUESTED });
const fetchProfileFailure = () => ({ type: FETCH_PROFILE_FAILURE });

const fetchProfileSuccess = data => ({
  type: FETCH_PROFILE_SUCCESS,
  payload: {
    isLoggedInUsersProfile: data.isLoggedInUsersProfile,
    description: data.characterName,
    currentArea: data.currentArea,
    profileCharacter: data.profileCharacter,
    standardEquipped: data.standardEquippedPossessions,
    expandedEquipped: data.expandedEquippedPossessions,
    sharedContent: data.sharedContent,
    next: data.next,
    prev: data.prev,
  },
});

const profileService = new ProfileService();

/** ----------------------------------------------------------------------------
 * FETCH PROFILE
 -----------------------------------------------------------------------------*/
export default function fetchProfile(characterName, fromEchoId) {
  return (dispatch) => {
    dispatch(fetchProfileRequest());
    profileService.fetchProfile(characterName, fromEchoId).then((response) => {
      dispatch(fetchProfileSuccess(response.data));
    }).catch((message) => {
      dispatch(fetchProfileFailure(message));
    });
  };
}
